"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var moment_1 = __importDefault(require("moment"));
var Model_1 = require("../../Model");
var NON_COLLECTION_REASON;
(function (NON_COLLECTION_REASON) {
    NON_COLLECTION_REASON["SHOP_CLOSED"] = "SHOP_CLOSED";
    NON_COLLECTION_REASON["PICKUP_CANCELLED"] = "PICKUP_CANCELLED";
    NON_COLLECTION_REASON["SHIPMENTS_NOT_PACKED"] = "SHIPMENTS_NOT_PACKED";
})(NON_COLLECTION_REASON = exports.NON_COLLECTION_REASON || (exports.NON_COLLECTION_REASON = {}));
var COLLECTION_LOG_STATES;
(function (COLLECTION_LOG_STATES) {
    COLLECTION_LOG_STATES["COLLECTION_AT_WAREHOUSE"] = "COLLECTION_AT_WAREHOUSE";
    COLLECTION_LOG_STATES["COLLECTION_COLLECTED"] = "COLLECTION_COLLECTED";
    COLLECTION_LOG_STATES["COLLECTION_NOT_COLLECTED"] = "COLLECTION_NOT_COLLECTED";
    COLLECTION_LOG_STATES["COLLECTION_MARKED_FOR_COLLECTION"] = "COLLECTION_MARKED_FOR_COLLECTION";
})(COLLECTION_LOG_STATES = exports.COLLECTION_LOG_STATES || (exports.COLLECTION_LOG_STATES = {}));
var CollectionTour = /** @class */ (function () {
    function CollectionTour() {
    }
    /**
     * Retrieves the weekly collection tours for the current subcontractor.
     * @param {number} subcoId The current subcontractor id.
     * @returns {Promise<ICollectionTour[]>} The collection tours for the subcontractor.
     */
    CollectionTour.getSubcoWeek = function (subcoId) {
        return Model_1.Model.makeRequest("/spatial/functions/collection-tours/" + subcoId, Model_1.METHOD.GET);
    };
    /**
     * Saves the tours for a specific date and a subcontractor.
     * @param {ISaveCollectionTourInput} input The date input with the tours to save.
     * @returns {Promise<ICollectionTour[]>} The created collection tours for the subcontractor.
     */
    CollectionTour.saveCollectionTours = function (input) {
        return Model_1.Model.makeRequest('/spatial/functions/store-collection-tour/', Model_1.METHOD.POST, input);
    };
    /**
     * Fetches the tour templates from Google Drive and saves them to the database, discards
     * old tours
     * @returns {Promise<IPublishTourValidations>} all validation warnings encountered during the reading of the template
     */
    CollectionTour.publishTours = function () {
        return Model_1.Model.makeRequest("/spatial/functions/collection/tour/publish", Model_1.METHOD.POST);
    };
    /**
     * Retrieves the tour assigned to a driver
     * @param {number} driverId The current driver id.
     * @returns {Promise<IDriverCollectionTour>} The collection tour for the driver.
     */
    CollectionTour.getTourForDriver = function (driverId) {
        return Model_1.Model.makeRequest("/spatial/functions/collection-tour-for-driver/" + driverId, Model_1.METHOD.GET);
    };
    /**
     * Starts the drivers collection tour for today.
     * @param licensePlate string The license plate of the driver.
     */
    CollectionTour.start = function (licensePlate) {
        return Model_1.Model.makeRequest('/spatial/functions/collection/tour/start', Model_1.METHOD.PUT, { licensePlate: licensePlate });
    };
    /**
     * Collect a collection. For driver app's consumption
     */
    CollectionTour.collectCollection = function (collectionId, input) {
        return Model_1.Model.makeRequest("/delivery/functions/collection/" + collectionId + "/collected", Model_1.METHOD.PUT, input);
    };
    /**
     * Not collect a collection. For driver app's consumption
     */
    CollectionTour.notCollectCollection = function (collectionId, input) {
        return Model_1.Model.makeRequest("/delivery/functions/collection/" + collectionId + "/not-collected", Model_1.METHOD.PUT, input);
    };
    /**
     * Completes the drivers collection tour for today.
     */
    CollectionTour.complete = function () {
        return Model_1.Model.makeRequest('/spatial/functions/collection/tour/complete', Model_1.METHOD.PUT);
    };
    /**
     * Gets a list of collection tours for a specific subcontractor and date.
     * @param {number} subcoId The subcontractor id to query.
     * @param {string} date The date for the specified query. If a date is not supplied, uses CURRENT_DATE instead
     * @returns {Promise<ICollectionTourTrackingResponseRow[]>} The list of collection tours for subcoId and date.
     */
    CollectionTour.fetchCollectionTourTracking = function (subcoId, date) {
        var dateString = '';
        if (date) {
            dateString = "?date=" + moment_1.default(date).format('YYYY-MM-DD');
        }
        return Model_1.Model.makeRequest("/delivery/functions/collection-tour-tracking/" + subcoId + dateString, Model_1.METHOD.GET);
    };
    /**
     * Gets a single collection tour and it's details.
     * @param {number} tourId The tourId to query.
     * @returns {Promise<ICollectionTourDetails>} The details of a single
     * collection tour, including its stops and driver
     */
    CollectionTour.fetchCollectionTourView = function (tourId) {
        return Model_1.Model.makeRequest("/delivery/functions/collection-tour/" + tourId, Model_1.METHOD.GET);
    };
    /**
     * Gets a list of collection tour estimations for a specific subcontractor and date.
     * @param {number} subcoId The subcontractor id to query.
     * @param {string} date The date for the specified query. If a date is not supplied, uses CURRENT_DATE instead
     * @returns {Promise<ICollectionTourTrackingResponseRow[]>} The list of collection tours for subcoId and date.
     */
    CollectionTour.fetchCollectionTourEstimations = function (subcoId) {
        return Model_1.Model.makeRequest("/delivery/functions/collection-tour-estimation/" + subcoId, Model_1.METHOD.GET);
    };
    /**
     * Gets a single collection tour and it's shops' estimations.
     * @param {number} tourId The tourId to query.
     * @returns {Promise<ISingleCollectionTourEstimation>} The estimation of a single
     * collection tour's time of arrival including its shops and their addresses
     */
    CollectionTour.fetchSingleCollectionTourEstimation = function (tourId) {
        return Model_1.Model.makeRequest("/delivery/functions/collection-tour-estimation-view/" + tourId, Model_1.METHOD.GET);
    };
    /**
     * Checks if there is currently a VRP task running
     */
    CollectionTour.isVRPCurrentlyRunning = function () {
        return Model_1.Model.makeRequest('/optimization/public/is-task-running', Model_1.METHOD.GET);
    };
    /**
     * Starts the VRP for collections routes, based on the latest
     * google sheet.
     * @returns {void} The estimation of a single
     */
    CollectionTour.startCollectionTourVRPFromGoogleSheet = function () {
        return Model_1.Model.makeRequest('/spatial/functions/start/collections/vrp', Model_1.METHOD.GET);
    };
    return CollectionTour;
}());
exports.CollectionTour = CollectionTour;
